import { ExportOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import type { ClientFormValues } from '../models/Forms';
import { resolveIdentityDocumentValidationCountry } from '../market/resolveIdentityDocumentValidationCountry';
import { I18nNameSpaces } from '../services/i18n';

import { resolveIdentityDocumentRegistryFeedback } from './documentRegistryFeedbackState';
import { getIdentityDocumentRegistryPublicUrl } from './identityDocumentRegistryPublicUrl';

export function DocumentRegistryFeedbackBanner() {
  const { values } = useFormikContext<ClientFormValues>();
  const { t } = useTranslation(I18nNameSpaces.Forms);
  const feedback = resolveIdentityDocumentRegistryFeedback(values);

  if (!feedback) {
    return null;
  }

  const country = resolveIdentityDocumentValidationCountry();
  const registryPublicUrl = country
    ? getIdentityDocumentRegistryPublicUrl(country, {
        identification: values.identification,
        identificationNumber: values.identificationNumber,
      })
    : undefined;

  const registryLinkLabel = country
    ? t(`clientForm.identityDocumentValidation.registryLink.${country}`)
    : '';

  const description =
    registryPublicUrl && country ? (
      <a
        href={registryPublicUrl}
        target="_blank"
        rel="noopener noreferrer"
        title={t('clientForm.identityDocumentValidation.registryLinkOpensInNewTab')}
        aria-label={`${registryLinkLabel}. ${t('clientForm.identityDocumentValidation.registryLinkOpensInNewTab')}`}
      >
        {registryLinkLabel}
        <ExportOutlined aria-hidden style={{ marginLeft: 4 }} />
      </a>
    ) : undefined;

  return (
    <Alert
      className="identity-document-registry-feedback"
      type={feedback.tone}
      showIcon
      title={t(feedback.messageKey)}
      description={description}
    />
  );
}
